export default __webpack_public_path__ + "static/media/shujuqueshi.b39a87ea.svg";